export default __webpack_public_path__ + "static/220803_天下布魔更新內容預告_en-d363bb877284335eab8e24c83bc5e56b.webp";